// SimpleCoordinatesSection.js
import React from 'react';
import { MapPin, AlertCircle } from 'lucide-react';
import SimplifiedMapWithSearch from './../maps/SimplifiedMapWithSearch';

const SimpleCoordinatesSection = ({
  coordinates,
  onCoordinateChange,
  onGenerateCoordinates,
  isGenerating,
  error,
  placeName,
  isRequired = true,
  disabled = false
}) => {
  // Direct coordinate update functions
  const updateLatitude = (value) => {
    console.log(`Direct latitude update to: ${value}, disabled: ${disabled}`);
    onCoordinateChange('latitude', value);
  };

  const updateLongitude = (value) => {
    console.log(`Direct longitude update to: ${value}, disabled: ${disabled}`);
    onCoordinateChange('longitude', value);
  };

  return (
    <div className={`space-y-4 ${disabled ? 'opacity-60' : ''}`}>
      <h4 className="text-md font-medium flex items-center gap-2">
        <MapPin className="w-4 h-4" />
        Location Coordinates {isRequired && <span className="text-red-500">*</span>}
        {disabled && <span className="text-gray-500 text-xs ml-2">(View Only)</span>}
      </h4>
      
      <div className="grid grid-cols-2 gap-4">
        {/* Latitude input */}
        <div className="space-y-1">
          <label className="block text-sm font-medium mb-1">
            Latitude {isRequired && <span className="text-red-500">*</span>}
          </label>
          <input
            type="text"
            className={`w-full p-2 border rounded ${error ? 'border-red-500' : ''} ${isRequired && !coordinates.latitude ? 'border-yellow-500' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={coordinates.latitude || ''}
            onChange={(e) => updateLatitude(e.target.value)}
            placeholder={disabled ? "View Only Mode" : "e.g., 51.5074"}
            disabled={disabled}
          />
        </div>

        {/* Longitude input */}
        <div className="space-y-1">
          <label className="block text-sm font-medium mb-1">
            Longitude {isRequired && <span className="text-red-500">*</span>}
          </label>
          <input
            type="text"
            className={`w-full p-2 border rounded ${error ? 'border-red-500' : ''} ${isRequired && !coordinates.longitude ? 'border-yellow-500' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            value={coordinates.longitude || ''}
            onChange={(e) => updateLongitude(e.target.value)}
            placeholder={disabled ? "View Only Mode" : "e.g., -0.1278"}
            disabled={disabled}
          />
        </div>
      </div>
      
      {/* Error message */}
      {error && <p className="text-red-500 text-sm">{error}</p>}
      {isRequired && (!coordinates.latitude || !coordinates.longitude) && !error && (
        <p className="text-yellow-600 text-sm flex items-center gap-1">
          <AlertCircle className="w-3 h-3" /> Location coordinates are required
        </p>
      )}
      
      {/* Map with Search and Extract Buttons */}
      <div className={`mt-2 p-4 bg-gray-50 rounded-lg border ${disabled ? 'pointer-events-none opacity-60' : ''}`}>
        <SimplifiedMapWithSearch
          latitude={coordinates.latitude}
          longitude={coordinates.longitude}
          onCoordinateChange={disabled ? () => {} : onCoordinateChange}
          disabled={disabled}
          initialShowMap={true}
        />
        <p className="text-xs text-gray-500 mt-2">
          {disabled
            ? "View Only Mode - Map interaction is disabled"
            : "Search for a location or click on the map to place a marker, then use the buttons to extract the coordinates."}
        </p>
      </div>

    
     
    </div>
  );
};

export default SimpleCoordinatesSection;
